import { Component } from 'react';
import { withApollo } from 'react-apollo';
import { compose } from 'recompose';
import { initLocalCache } from 'graphql/resolvers';

export class UnauthAccess extends Component {
  componentDidMount() {
    const { client } = this.props;
    initLocalCache(client.cache);
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

const enhance = compose(withApollo);

export default enhance(UnauthAccess);
